import { uiConstants } from "../constants";
import store from "../lib/store";

export function sideBarOpen(open) {
  store.dispatch({
    type: uiConstants.UPDATE_MENU_STATE,
    payload: open
  });
}

export function searchBarToggle(open) {
  return async (dispatch) => {
    try {
      dispatch({
        type: uiConstants.SEARCH_BAR_TOGGLE,
        payload: open
      });
    } catch (error) {
      console.log(error);
    }
  };
}